<template lang="pug">
  .tariff-carousel
    Swiper.carousel(ref="tariffsCarousel" :options="{ slidesPerView: 1, grabCursor: true }")
      SwiperSlide.slide(v-for="item in $store.getters['tariff/itemsToShowFiltered']" :key="item.id")
        .item
          .pre-title {{ activeTariff === item ? 'Ваш тариф' : '' }}
          .name {{ item.name }}
          .price {{ item.pricePerDay * 30 }} ₽
          .desc(v-if="item.pricePerDay > 0") Месяц | {{ item.pricePerDay }} ₽/день
          .desc(v-else) Бессрочно
          .options
            .value {{ item.maxProjects }}
            .name Количество проектов
            .value {{ item.maxStorage }}
            .name Место в хранилище, ГБ
            template(v-for="(option, i) in item.options")
              .value
                Icon(:name="option ? 'checked-true-sm' : 'checked-cross'")
              .name {{ options[i] }}
          Btn(lg round :to="{ name: 'tariffs' }") Поменять тариф
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: 'TariffCarousel',
  components: { Swiper, SwiperSlide },
  data() {
    return {
      items: [],
      options: [
        'Систематизация работы',
        'Контроль сроков',
        'Коммуникация',
        'Тайм трекинг',
        'Отчеты',
        'Диаграмма Ганта',
        'Канбан',
        'Команды',
      ],
    };
  },
  created() {
    this.$store.dispatch('tariff/fetchItems');
  },
  computed: {
    activeTariff() {
      return this.items.find((t) => t.id === this.$store.state.auth.user.tariff) ?? {};
    },
  },
  methods: {
    prev() {
      const swiper = this.$refs?.tariffsCarousel?.$swiper;
      swiper.slideTo(swiper.activeIndex - 1);
    },
    next() {
      const swiper = this.$refs?.tariffsCarousel?.$swiper;
      swiper.slideTo(swiper.activeIndex + 1);
    },
  },
};
</script>

<style lang="scss">
  .tariff-carousel {
    position: relative;
    left: -20px;
    width: calc(100% + 40px);
    height: 100%;

    .carousel {
      height: 100%;
      box-sizing: border-box;
    }

    .slide {
      height: 100%;
      padding: 20px;
      box-sizing: border-box;
    }

    .item {
      min-height: 100%;
      box-sizing: border-box;
      border-radius: 8px;
      background: url("/img/tariff-bg.png") center center no-repeat;
      background-size: cover;
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
      padding: 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .pre-title {
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      letter-spacing: 0.01em;
      color: #FFFFFF;
    }

    .name {
      font-weight: 500;
      font-size: 32px;
      line-height: 40px;
      letter-spacing: 0.01em;
      color: #FFFFFF;
    }

    .price {
      font-weight: 700;
      font-size: 30px;
      line-height: 38px;
      letter-spacing: 0.01em;
      color: #33A1FB;
    }

    .desc {
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      letter-spacing: 0.01em;
      color: #FFFFFF;
      margin-bottom: 27px;
    }

    .options {
      display: grid;
      grid-template-columns: auto auto;
      gap: 7px 9px;
      align-items: center;
      margin-bottom: 27px;

      .name {
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        letter-spacing: 0.02em;
        color: #FFFFFF;
      }

      .value {
        color: #fff;
      }
    }
  }

  // CSS Grid/Flexbox bug size workaround
  // @see https://github.com/kenwheeler/slick/issues/982
  // no scoped
  .tariff-carousel {
    display: grid;

    .swiper-container{
      height: 100%;
      //max-height: 100vw;
      min-height: 0;
      min-width: 0;
      max-width: 100vw;
      width: 100%;
      overflow: hidden;
    }

    .swiper-slide{
      width: auto;
      flex-shrink: 0;
      display: block;
      height: 100%;
      max-height: 100%;
    }

    .swiper-wrapper{
      max-height: 100%;
      height: 100%;
      display: flex;
      min-height: 0;
      min-width: 0;
    }
  }
</style>
